<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Especialidade</th>
          <th>Avaliação</th>
          <th>Situação</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="f in formularios" :key="f._id">
          <td>{{ f.nome }}</td>
          <td>{{ f.especialidade.nome }}</td>
          <td>{{ f.avaliacao ? 'Sim' : 'Não' }}</td>
          <td>{{ f.ativo ? 'Ativo' : 'Cancelado' }}</td>
          <td>
            <RouterLink
              v-tooltip="'Editar'"
              data-test-id="link-auto-1"
              :to="'/evolucao/formulario/cadastro/' + f._id"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-edit" />
            </RouterLink>
            <button
              v-tooltip="'Duplicar'"
              data-test-id="button-duplicar-2"
              class="btn btn-xs btn-link"
              @click="duplicar(f)"
            >
              <span class="fa fa-copy" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { alertaMixin } from '@/mixins/AlertaMixin'

export default {
  name: 'FormularioTabela',
  mixins: [alertaMixin],
  props: {
    formularios: {
      type: Array,
      required: true,
    },
  },
  methods: {
    duplicar(formulario) {
      this.$emit('duplicar', formulario)
    },
  },
}
</script>
